module.exports = __webpack_public_path__ + "static/media/TableAbrasion_Before.2a742531.jpg";